export default __webpack_public_path__ + "static/media/Rock.e79a5838.svg";